import { render, staticRenderFns } from "./spiritualLaborApproval.vue?vue&type=template&id=6e2c17ca&scoped=true&"
import script from "./spiritualLaborApproval.vue?vue&type=script&lang=js&"
export * from "./spiritualLaborApproval.vue?vue&type=script&lang=js&"
import style0 from "./spiritualLaborApproval.vue?vue&type=style&index=0&id=6e2c17ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c17ca",
  null
  
)

export default component.exports